import 'bootstrap-icons/font/bootstrap-icons.scss';

export default defineNuxtPlugin(() => {});
